import { render, staticRenderFns } from "./Roll.vue?vue&type=template&id=9135d03c&scoped=true&"
import script from "./Roll.vue?vue&type=script&lang=js&"
export * from "./Roll.vue?vue&type=script&lang=js&"
import style0 from "./Roll.vue?vue&type=style&index=0&id=9135d03c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9135d03c",
  null
  
)

export default component.exports